(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about_kaitori"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function () {
  $(".position_fixed").each(function () {

      var boxTop = $(".left_contents").offset().top;
      var scroll = $(window).scrollTop();
      var positionRightTop = $(".secend").offset().top;
      var height = $(".secend").height();

      //画面内のどの位置で処理を実行するかで「100」の値を変更
      if (scroll < boxTop) {
          $(this).removeClass('side_fixed');
      }
      if (scroll > boxTop - 150) {
          $(this).addClass('side_fixed');
      }
      if (scroll > positionRightTop + height - 400) {
          $(this).removeClass('side_fixed');
      }
  });
});

// サイドバー２固定
$(window).on('scroll', function () {
  $(".position_fixed02").each(function () {

      var boxTop = $(".left_contents").offset().top;
      var scroll = $(window).scrollTop();
      var positionRightTop = $(".secend").offset().top;
      var height = $(".secend").height();

      //画面内のどの位置で処理を実行するかで「100」の値を変更
      if (scroll < boxTop) {
          $(this).removeClass('side_fixed02');
      }
      if (scroll > boxTop - 150) {
          $(this).addClass('side_fixed02');
      }
      if (scroll > positionRightTop + height) {
          $(this).removeClass('side_fixed02');
      }
  });
});


//   サイドバーアニメーション
$(window).on('scroll', function () {
  $(".lineAnimation1").each(function () {
      let position1 = $(".sec01").offset().top;
      let position2 = $(".sec02").offset().top;
      let scroll = $(window).scrollTop();
      if (scroll < position1 - 100) {
          $(this).removeClass('isActive');
      } if (scroll > position1 - 100) {
          $(this).addClass('isActive');
      } if (scroll > position2 - 100) {
          $(this).removeClass('isActive');
      }
  });
});

$(window).on('scroll', function () {
  $(".lineAnimation2").each(function () {
      let position1 = $(".sec02").offset().top;
      let position2 = $(".secend").offset().top;
      let scroll = $(window).scrollTop();
      if (scroll < position1 - 100) {
          $(this).removeClass('isActive');
      } if (scroll > position1 - 100) {
          $(this).addClass('isActive');
      } if (scroll > position2 - 100) {
          $(this).removeClass('isActive');
      }
  });
});

$(window).on('scroll', function () {
  $(".lineAnimation3").each(function () {
      let position1 = $(".secend").offset().top;
      let scroll = $(window).scrollTop();
      if (scroll < position1 - 100) {
          $(this).removeClass('isActive');
      } if (scroll > position1 - 100) {
          $(this).addClass('isActive');
      } if (scroll > position1 + 500) {
          $(this).removeClass('isActive');
      }
  });
});

//   サイドバーアニメーション2
$(window).on('scroll', function () {
  $(".lineAnimation11").each(function () {
      let position1 = $(".sec01").offset().top;
      let position2 = $(".sec02").offset().top;
      let scroll = $(window).scrollTop();
      if (scroll < position1 - 100) {
          $(this).removeClass('bwcolor');
      } if (scroll > position1 - 100) {
          $(this).addClass('bwcolor');
      } if (scroll > position2 - 100) {
          $(this).removeClass('bwcolor');
      }
  });
});

$(window).on('scroll', function () {
  $(".lineAnimation12").each(function () {
      let position1 = $(".sec02").offset().top;
      let position2 = $(".sec03").offset().top;
      let scroll = $(window).scrollTop();
      if (scroll < position1 - 100) {
          $(this).removeClass('bwcolor');
      } if (scroll > position1 - 100) {
          $(this).addClass('bwcolor');
      } if (scroll > position2 - 100) {
          $(this).removeClass('bwcolor');
      }
  });
});

$(window).on('scroll', function () {
  $(".lineAnimation13").each(function () {
      let position1 = $(".sec03").offset().top;
      let scroll = $(window).scrollTop();
      if (scroll < position1 - 100) {
          $(this).removeClass('bwcolor');
      } if (scroll > position1 - 100) {
          $(this).addClass('bwcolor');
      } if (scroll > position1 + 1000) {
          $(this).removeClass('bwcolor');
      }
  });
});


$('.responsive').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 400,
  responsive: [
      {
          breakpoint: 1024,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
          }
      },
      {
          breakpoint: 600,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      }
  ]
});

$('.responsive2').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 400,
  responsive: [
      {
          breakpoint: 1024,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
          }
      },
      {
          breakpoint: 600,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
      }
  ]
});

//アコーディオン
jQuery(function ($) {
  $('.toggle_title').click(function () {
      $(this).toggleClass('selected');
      $(this).next().slideToggle();
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaitori02"] && !Shopify.designMode) return;
  try {
    

$(function () {
  // タイトルをクリックすると
  $(".js-accordion-title").on("click", function () {
    // クリックしたタイトル以外のopenクラスを外す(－から＋にする)
    $(".js-accordion-title").not(this).removeClass("open");
    // クリックしたタイトル以外のコンテンツを閉じる
    $(".js-accordion-title").not(this).next().slideUp(300);
    // クリックしたタイトルにopenクラスを付け外しして＋と－を切り替える
    $(this).toggleClass("open");
    // クリックしたタイトルの次の要素(コンテンツ)を開閉
    $(this).next().slideToggle(300);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-store"] && !Shopify.designMode) return;
  try {
    

  // トップサイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".store_left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 200){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -100){
    $(this).removeClass('side_fixed');
    }
});

});

//   トップサイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimationt1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 180){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 180){
    $(this).addClass('isActive');
    }if(scroll > position2 -240){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimationt2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 180){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 180){
    $(this).addClass('isActive');
    }if(scroll > position2 -240){
    $(this).removeClass('isActive');
    }
});
});
$(window).on('scroll',function(){
$(".lineAnimationt3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 180){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 180){
    $(this).addClass('isActive');
    }if(scroll > position2 -240){
    $(this).removeClass('isActive');
    }
});
});
$(window).on('scroll',function(){
$(".lineAnimationt4").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 180){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 180){
    $(this).addClass('isActive');
    }if(scroll > position2 -240){
    $(this).removeClass('isActive');
    }
});
});
$(window).on('scroll',function(){
$(".lineAnimationt5").each(function(){
    let position1 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 180){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 180){
    $(this).addClass('isActive');
    }
});
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_company"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -400){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position1 +500){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_faq"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -150){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 300){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 300){
    $(this).addClass('isActive');
    }if(scroll > position2 -300){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 300){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 300){
    $(this).addClass('isActive');
    }if(scroll > position2 -300){
    $(this).removeClass('isActive');
    }
});
});
$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 300){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 300){
    $(this).addClass('isActive');
    }if(scroll > position2 -300){
    $(this).removeClass('isActive');
    }
});
});
$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 300){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 300){
    $(this).addClass('isActive');
    }if(scroll > position2 -300){
    $(this).removeClass('isActive');
    }
});
});
$(window).on('scroll',function(){
$(".lineAnimation5").each(function(){
    let position1 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 300){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 300){
    $(this).addClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -300){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -300){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -300){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -300){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -300){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -300){
    $(this).removeClass('bwcolor');
    }
});
  
});
$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -300){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -300){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -300){
    $(this).removeClass('bwcolor');
    }
});
});
$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -300){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -300){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -300){
    $(this).removeClass('bwcolor');
    }
});
});
$(window).on('scroll',function(){
$(".lineAnimation15").each(function(){
    let position1 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -300){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -300){
    $(this).addClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_guide"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -600){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation5").each(function(){
    let position1 = $(".sec05").offset().top;
    let position2 = $(".sec06").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation6").each(function(){
    let position1 = $(".sec06").offset().top;
    let position2 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation7").each(function(){
    let position1 = $(".sec07").offset().top;
    let position2 = $(".sec08").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation8").each(function(){
    let position1 = $(".sec08").offset().top;
    let position2 = $(".sec10").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

// $(window).on('scroll',function(){
// $(".lineAnimation9").each(function(){
//     let position1 = $(".sec09").offset().top;
//     let position2 = $(".sec10").offset().top;
//     let scroll = $(window).scrollTop();
//     if (scroll < position1 - 200){
//     $(this).removeClass('isActive');
//     }if (scroll > position1 - 200){
//     $(this).addClass('isActive');
//     }if(scroll > position2 -200){
//     $(this).removeClass('isActive');
//     }
// });
// });

$(window).on('scroll',function(){
$(".lineAnimation010").each(function(){
    let position1 = $(".sec10").offset().top;
    let position2 = $(".sec11").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

  $(window).on('scroll',function(){
$(".lineAnimation011").each(function(){
    let position1 = $(".sec11").offset().top;
    let position2 = $(".sec12").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation012").each(function(){
    let position1 = $(".sec12").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +200){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation15").each(function(){
    let position1 = $(".sec05").offset().top;
    let position2 = $(".sec06").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation16").each(function(){
    let position1 = $(".sec06").offset().top;
    let position2 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation17").each(function(){
    let position1 = $(".sec07").offset().top;
    let position2 = $(".sec08").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation18").each(function(){
    let position1 = $(".sec08").offset().top;
    let position2 = $(".sec09").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation19").each(function(){
    let position1 = $(".sec09").offset().top;
    let position2 = $(".sec10").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation20").each(function(){
    let position1 = $(".sec10").offset().top;
    let position2 = $(".sec11").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

  $(window).on('scroll',function(){
$(".lineAnimation21").each(function(){
    let position1 = $(".sec11").offset().top;
    let position2 = $(".sec12").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation22").each(function(){
    let position1 = $(".sec12").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_pricelist"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -600){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation5").each(function(){
    let position1 = $(".sec05").offset().top;
    let position2 = $(".sec06").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation6").each(function(){
    let position1 = $(".sec06").offset().top;
    let position2 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation7").each(function(){
    let position1 = $(".sec07").offset().top;
    let position2 = $(".sec08").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation8").each(function(){
    let position1 = $(".sec08").offset().top;
    let position2 = $(".sec09").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation9").each(function(){
    let position1 = $(".sec09").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +200){
    $(this).removeClass('isActive');
    }
});
});
  $(window).on('scroll',function(){
$(".lineAnimation10").each(function(){
    let position1 = $(".sec010").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation101").each(function(){
    let position1 = $(".sec11").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +200){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation15").each(function(){
    let position1 = $(".sec05").offset().top;
    let position2 = $(".sec06").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation16").each(function(){
    let position1 = $(".sec06").offset().top;
    let position2 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation17").each(function(){
    let position1 = $(".sec07").offset().top;
    let position2 = $(".sec08").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation18").each(function(){
    let position1 = $(".sec08").offset().top;
    let position2 = $(".sec09").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

  $(window).on('scroll',function(){
$(".lineAnimation19").each(function(){
    let position1 = $(".sec09").offset().top;
    let position2 = $(".sec10").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
    $(window).on('scroll',function(){
$(".lineAnimation20").each(function(){
    let position1 = $(".sec10").offset().top;
    let position2 = $(".sec11").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation201").each(function(){
    let position1 = $(".sec11").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_privacy"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -400){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position1 +500){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +1000){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_recruit"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -200){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position1 +500){
    $(this).removeClass('isActive');
    }
});
});


//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +300){
    $(this).removeClass('bwcolor');
    }
});
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_staff"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -600){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation5").each(function(){
    let position1 = $(".sec05").offset().top;
    let position2 = $(".sec06").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation6").each(function(){
    let position1 = $(".sec06").offset().top;
    let position2 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation7").each(function(){
    let position1 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +200){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation15").each(function(){
    let position1 = $(".sec05").offset().top;
    let position2 = $(".sec06").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation16").each(function(){
    let position1 = $(".sec06").offset().top;
    let position2 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation17").each(function(){
    let position1 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_store_01"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -600){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation5").each(function(){
    let position1 = $(".sec05").offset().top;
    let position2 = $(".sec06").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation6").each(function(){
    let position1 = $(".sec06").offset().top;
    let position2 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position2 -100){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation7").each(function(){
    let position1 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 100){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 100){
    $(this).addClass('isActive');
    }if(scroll > position1 +500){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let position2 = $(".sec05").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation15").each(function(){
    let position1 = $(".sec05").offset().top;
    let position2 = $(".sec06").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation16").each(function(){
    let position1 = $(".sec06").offset().top;
    let position2 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation17").each(function(){
    let position1 = $(".sec07").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_store_02"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -400){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +500){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_store_03"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -400){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +500){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_store_05"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -400){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +500){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["under_store_06"] && !Shopify.designMode) return;
  try {
    

// サイドバー固定
$(window).on('scroll', function (){
  $(".position_fixed").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed');
    } 
    if(scroll > positionRightTop + height -400){
    $(this).removeClass('side_fixed');
    }
});
});

// サイドバー２固定
$(window).on('scroll', function (){
  $(".position_fixed02").each(function(){

    var boxTop = $(".left_contents").offset().top;
    var scroll = $(window).scrollTop();
    var positionRightTop = $(".secend").offset().top;
    var height = $(".secend").height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
  if(scroll < boxTop){
    $(this).removeClass('side_fixed02');
    }
    if(scroll > boxTop - 150){
    $(this).addClass('side_fixed02');
    } 
    if(scroll > positionRightTop + height){
    $(this).removeClass('side_fixed02');
    }
});
});


//   サイドバーアニメーション
$(window).on('scroll',function(){
$(".lineAnimation1").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation2").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation3").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position2 -200){
    $(this).removeClass('isActive');
    }
});
});
  
$(window).on('scroll',function(){
$(".lineAnimation4").each(function(){
    let position1 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 - 200){
    $(this).removeClass('isActive');
    }if (scroll > position1 - 200){
    $(this).addClass('isActive');
    }if(scroll > position1 +500){
    $(this).removeClass('isActive');
    }
});
});

//   サイドバーアニメーション2
$(window).on('scroll',function(){
$(".lineAnimation11").each(function(){
    let position1 = $(".sec01").offset().top;
    let position2 = $(".sec02").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});
});

$(window).on('scroll',function(){
$(".lineAnimation12").each(function(){
    let position1 = $(".sec02").offset().top;
    let position2 = $(".sec03").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});

$(window).on('scroll',function(){
$(".lineAnimation13").each(function(){
    let position1 = $(".sec03").offset().top;
    let position2 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position2 -100){
    $(this).removeClass('bwcolor');
    }
});  
});
  
$(window).on('scroll',function(){
$(".lineAnimation14").each(function(){
    let position1 = $(".sec04").offset().top;
    let scroll = $(window).scrollTop();
    if (scroll < position1 -100){
    $(this).removeClass('bwcolor');
    }if (scroll > position1 -100){
    $(this).addClass('bwcolor');
    }if(scroll > position1 +500){
    $(this).removeClass('bwcolor');
    }
});
});


  } catch(e) { console.error(e); }
})();
})();
